module.exports = __webpack_public_path__ + "static/video-9017a47ab6ff01c8a4f7a1ac714178ce.webp";